// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","Logo":"Footer_Logo__8K5R3"};